import React from 'react';
import AuthLanding from '../components/auth/authLanding';
import HemaLogo from '../assets/images/HematogenixRed.svg';
import MfaForm from '../components/ClientPortal/mfaPage';

const PortalMfa = () => {
  return (
    <div className="flex w-full">
      {/* Left banner */}
      <AuthLanding className="bg-[url(../../assets/images/bg-set-reset-img.png)]" />

      {/* Right panel */}
      <div className="p-7 lg:pl-[70px] w-full lg:w-[50%] min-h-screen lg:min-h-auto bg-hemaSecondary">
        <div className="mt-8 lg:mt-[60px] mb-[104px]">
          <img src={HemaLogo} alt="Company logo" />
        </div>

        <MfaForm />
      </div>
    </div>
  );
};

export default PortalMfa;
